import type { StormBuildUpRowDef } from './stormBuildUpTypes';

/**
 * Bill Summary form of a section title that has user-appended text: the take-off
 * tables show the text as a colour-coded tag, but the summaries are plain text, so the
 * appended part is joined with " - " (e.g. "Carlow Tank 1 - NORTH").
 */
export const withDashedTitleSuffix = (rows: StormBuildUpRowDef[]): StormBuildUpRowDef[] =>
  rows.map((r) => {
    const suffix = r.titleSuffix;
    if (!r.isHeader || !suffix || !r.description.endsWith(` ${suffix}`)) return r;
    return { ...r, description: `${r.description.slice(0, r.description.length - suffix.length - 1)} - ${suffix}` };
  });

/**
 * Take-off form of per-section titles (Ponds & Swales pattern): appends the text typed for a
 * section (`sectionTitles[headerId]`) to that header row and records it as `titleSuffix`, so
 * StormBuildUpTable colour-codes it and the pencil editor can pre-fill it.
 */
export const applySectionTitles = (rows: StormBuildUpRowDef[], sectionTitles: Record<string, string> = {}): StormBuildUpRowDef[] =>
  rows.map((r) => {
    const text = r.isHeader ? sectionTitles[r.id]?.trim() : undefined;
    return text ? { ...r, description: `${r.description} ${text}`, titleSuffix: text } : r;
  });
